import { render, staticRenderFns } from "./gradeModalProfile.vue?vue&type=template&id=4255c2cc&"
import script from "./gradeModalProfile.vue?vue&type=script&lang=js&"
export * from "./gradeModalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports